<template>
  <div class="page_print">
    <div class="printMain">
      <div class="tabBox" id="printBox" v-if="showPrint">
        <div v-for="(printItem, index) in printList" :key="index" class="printItem">
          <div class="noteTitle">员工应征登记表</div>
          <table width="100%" border="0" cellspacing="1" cellpadding="4" class="invoiceTable" align="center" style="border: 2px solid #000;">
            <tr>
              <td width="12%" class="font-center titfont">◆姓名</td>
              <td width="12%" class="font-center ">{{ printItem.name }}</td>
              <td width="12%" class="font-center titfont">◆性别</td>
              <td width="12%" class="font-center "> {{ printItem.gender }}</td>
              <td width="12%" class="font-center titfont">◆民族</td>
              <td width="12%" class="font-center "> {{ printItem.ethnicity }}</td>
              <td width="18%" colspan="2" rowspan="6">
                <div class="photoBox">
                  <div>照</div>
                  <div style="margin-top: 20px;">片</div>
                </div>
              </td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">◆出生日期</td>
              <td width="12%" class="font-center ">{{ printItem.birthDate }}</td>
              <td width="12%" class="font-center titfont">◆籍贯</td>
              <td width="12%" class="font-center ">{{ printItem.originPlace }}</td>
              <td width="12%" class="font-center titfont">◆学历</td>
              <td width="12%" class="font-center ">{{ printItem.educationalQualifications }}</td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">所学专业</td>
              <td width="12%" class="font-center "></td>
              <td class="font-center titfont" colspan="2">◆身份证号码</td>
              <td class="font-center " colspan="2">{{ printItem.identityCard }}</td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">◆婚姻状况</td>
              <td width="12%" class="font-center ">{{ printItem.marriage }}</td>
              <td width="12%" class="font-center titfont">身高</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont">是否近视/度数</td>
              <td width="12%" class="font-center "></td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">体重</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont">身体状态</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont">有何资格证书</td>
              <td width="12%" class="font-center "></td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">◆联系电话</td>
              <td width="12%" class="font-center ">{{ printItem.mobilePhone }}</td>
              <td width="12%" class="font-center titfont">QQ</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont">常用电子邮件</td>
              <td width="12%" class="font-center "></td>
            </tr>
            <tr>
              <td class="font-center titfont">◆家庭电话</td>
              <td class="font-center " colspan="3"></td>
              <td class="font-center titfont" colspan="2">◆紧急联系人姓名与电话</td>
              <td class="font-center " colspan="2">{{ printItem.emergencyName && printItem.emergencyTel ? printItem.emergencyName + '/' + printItem.emergencyTel : ''}}</td>
            </tr>
            <tr>
              <td class="font-center titfont">◆现居通讯地址</td>
              <td class="font-center " colspan="3">{{ printItem.currentAddress }}</td>
              <td class="font-center titfont" colspan="2">◆身份证地址</td>
              <td class="font-center " colspan="2">{{ printItem.residentialAddress }}</td>
            </tr>
            <tr>
              <td class="font-center titfont">计算机水平</td>
              <td class="font-center"></td>
              <td class="font-center titfont" colspan="2">◆户粮关系</td>
              <td class="font-center" colspan="4">
                <div class="checkBox flex">
                  <el-checkbox v-model="printItem.checked">农村</el-checkbox>
                  <el-checkbox v-model="printItem.checked2">城镇</el-checkbox>
                </div>
              </td>
            </tr>
            <tr>
              <td class="font-center titfont">外语类别及水平</td>
              <td class="font-center" colspan="3"></td>
              <td class="font-center titfont">◆政治面貌</td>
              <td class="font-center" colspan="3">
                <div class="checkBox flex">
                  <el-checkbox-group v-model="printItem.checkList">
                    <el-checkbox label="党员"></el-checkbox>
                    <el-checkbox label="团员"></el-checkbox>
                    <el-checkbox label="群众"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </td>
            </tr>
            <tr>
              <td width="12%" class="font-center titfont">驾照及驾龄</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont" colspan="2">是否要安排住宿</td>
              <td width="12%" class="font-center "></td>
              <td width="12%" class="font-center titfont">期望薪资</td>
              <td width="12%" class="font-center " colspan="2"></td>
            </tr>
            <tr>
              <td class="font-center titfont" colspan="8">教育经历</td>
            </tr>
            <tr>
              <td class="font-center titfont" colspan="2">起止时间</td>
              <td class="font-center titfont" colspan="2">学校（培训单位）名称</td>
              <td class="font-center titfont" colspan="2">专业</td>
              <td class="font-center titfont" colspan="2">备注</td>
            </tr>
            <tr v-for="(edu,i) in printItem.educational" :key="'educational' + i">
              <td class="font-center" colspan="2">{{ edu.startEndTime && edu.startEndTime.indexOf('0001')==-1 ? edu.startEndTime : '' }}</td>
              <td class="font-center" colspan="2">{{ edu.schoolName }}</td>
              <td class="font-center" colspan="2">{{ edu.professional }}</td>
              <td class="font-center" colspan="2">{{ edu.remark }}</td>
            </tr>
            <tr>
              <td class="font-center titfont" colspan="8">工作及实习经历</td>
            </tr>
            <tr>
              <td class="font-center titfont">开始年月</td>
              <td class="font-center titfont">离开年月</td>
              <td class="font-center titfont" colspan="2">工作单位</td>
              <td class="font-center titfont" colspan="2">职务（岗位）</td>
              <td class="font-center titfont" colspan="2">离职原因</td>
            </tr>
            <tr v-for="(work,i) in printItem.work" :key="'work' + i">
              <td class="font-center">{{ work.startingWorkDate && work.startingWorkDate.indexOf('1900')==-1 ? work.startingWorkDate : '' }}</td>
              <td class="font-center">{{ work.resignationDate && work.resignationDate.indexOf('1900')==-1 ? work.resignationDate : ''}}</td>
              <td class="font-center" colspan="2">{{ work.organization }}</td>
              <td class="font-center" colspan="2">{{ work.position }}</td>
              <td class="font-center" colspan="2">{{ work.resignationReason }}</td>
            </tr>
            <tr>
              <td class="font-center titfont" colspan="8">家庭成员</td>
            </tr>
            <tr>
              <td class="font-center titfont">称谓</td>
              <td class="font-center titfont">姓名</td>
              <td class="font-center titfont">出生年月</td>
              <td class="font-center titfont" colspan="2">工作单位</td>
              <td class="font-center titfont">职务（工种）</td>
              <td class="font-center titfont" colspan="2">联系电话</td>
            </tr>
            <tr v-for="(member,i) in printItem.member" :key="'member' + i">
              <td class="font-center">{{ member.relationship }}</td>
              <td class="font-center">{{ member.name }}</td>
              <td class="font-center">{{ member.birthDate }}</td>
              <td class="font-center" colspan="2">{{ member.workplace }}</td>
              <td class="font-center">{{ member.position }}</td>
              <td class="font-center" colspan="2">{{ member.telephone }}</td>
            </tr>
            <tr>
              <td colspan="8">
                <div class="ensure">我保证,本表格所填各项内容属实，如有虚假，本人愿意接受公司任何处罚以及承担相应的经济与法律责任。</div>
                <div class="signatureBox">
                  <div class="signatureIMG">◆签名：
                    <img v-if="printItem.signature" :src="$store.state.EMP.imgPath + printItem.signature" alt="">
                  </div>
                  <div class="year" style="margin-left: 120px;"> {{ printItem.signatureTime ? printItem.signatureTime.split('-')[0] : ''}} 年</div>
                  <div class="year">{{ printItem.signatureTime ? printItem.signatureTime.split('-')[1] : ''}} 月</div>
                  <div class="year">{{ printItem.signatureTime ? printItem.signatureTime.split('-')[2] : ''}} 日</div>
                </div>
                <div class="signatureTips">
                  注：请在填写前认真阅读背后特别说明，并签字确认。
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="d1">
                  工作人员意见
                </div>
                <div class="d2 flex sb">
                  <div>签名：</div>
                  <div class="flex">
                    <div class="year" style="margin-left: 120px;">年</div>
                    <div class="year">月</div>
                    <div class="year">日</div>
                  </div>
                </div>
              </td>
              <td colspan="4">
                <div class="d1">
                  客户单位意见
                </div>
                <div class="d2 flex sb">
                  <div>签名：</div>
                  <div class="flex">
                    <div class="year" style="margin-left: 100px;">年</div>
                    <div class="year">月</div>
                    <div class="year">日</div>
                  </div>
                </div>
              </td>
            </tr>
          </table>

          <div class="noteBox">
            <div class="noteTitle">员工应征特别说明</div>
            <p>
              1、申请人在填写本人入职申请书时，已保证自己符合国家法定的劳动年龄的标准，且与其它任何机构、经济组织、团体无劳动关系；若违反前述承诺，导致用人单位被行政、诉讼或仲裁追究有关经济责任的，所有责任均由申请人承担。
            </p>
            <p>
              2、申请人如有传染病、精神病或其他可能影响在用人单位工作的病史，申请人应以书面形式向用人单位说明。
            </p>
            <p>
              3、如申请人与其他公司签订仍然生效的保密协议、竞业限制协议的，应以书面形式向公司说明情况。
            </p>
            <p>
              4、本人填写的本人入职申请表所有信息真实有效并授权用人单位或用人单位授权其他机构对本人填写内容进行核实，如有任何虚假，用人单位可按严重违反用人单位规章制度解除劳动合同，同时追究因此引起的所有责任。
            </p>
            <p>
              5、申请人入职后不得将与聘用有关的相关信息（包括但不限于工资）未经用人单位许可向第三方透露。
            </p>
            <p>
              6、申请人在职期间或离职后用人单位可以依法将申请人在本单位的工作状况对外公布或向有需要的第三方提供。
            </p>
            <p>
              7、如入职申请表中的信息有变化，申请人应在变更后的三天内以书面形式向公司提交变更申请，否则视同信息仍有效。
            </p>
            <p>
              8、如被公司录用，申请人有责任依法在一个月内与公司签订劳动合同；若不签订，视作自动放弃录用机会。
            </p>
            <p>
              9、申请人认真阅读并遵守员工手册及各项规章制度,清楚公司可以根据实际情况更新员工手册、规章制度与劳动纪律，申请人将随时关注公司在公司网站、布告栏（包括但不限于）等各种公示方式公示的更新后的员工手册、规章制度与劳动纪律并予以严格遵守。
            </p>
            <p>
              10、入职时如有任何兼职行为（包括但不限于直销），应以书面形式向公司说明情况，未经公司书面同意，不得从事任何形式的兼职行为。
            </p>
            <p>
              11、曾被追究刑事责任的，应在入职时以书面形式向公司说明情况。
            </p>
            <p>
              12、申请人已清楚了解公司的用工方式，能接受由此引起的岗位、薪酬、工作时间及工作地点的变化。
            </p>
            <p>
              13、未办理正常请假手续、续假手续，连续旷工3天（含）以上或一年内累计旷工6天（含）以上视为严重违纪，公司有权解除劳动关系并向员工发送手机信息、寄送信件至表中员工所填写的“现居通讯地址”或“身份证地址”，视为送达。
            </p>
            <p>
              14、此表仅作为个人求职申请表，不作为劳动关系的确认单。
            </p>
            <p>
              申请人填写的以上任何信息虚假或没有履行以上特殊说明的义务，本人同意被公司视为严重违反《劳动合同法》的诚实信用原则与用人单位的规章制度，公司可以即时解除劳动合同且不用支付经济补偿金。
            </p>

            <div class="noteBot flex sb">
              <div class="signatureIMG">申请人签字：
                <img v-if="printItem.signature" :src="$store.state.EMP.imgPath + printItem.signature" alt="">
              </div>
              <div class="printDate">日期：{{ printItem.signatureTime ? printItem.signatureTime : '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" @click="printClick('printBox', '')" size="small">打 印</el-button>
    </span>
  </div>
</template>

<script>
  import print from 'print-js';
  export default {
    props: {
      printList: {
        type: Array, // 类型为 String
        required: false, // 是否必填
        default: [{
          StrEmpName: '', // 姓名
          sex: '', // 性别
          StrNationClass: '', // 民族
          birth: '', // 出生日期
          StrNativePlace: '', // 籍贯
          StrEduLv: '', // 学历
          StrIdCard: '', // 身份证号码
          MarriageState: '', // 婚姻状况
          StrContName: '', // 紧急联系人姓名
          StrContTel: '', // 紧急联系人电话
          StrAddr: '', // 现居通讯地址
          InSchoolTime: null, // 入学时间（用于教育经历）
          OutSchoolTime: null, // 毕业时间（用于教育经历）
          SchoolName: '', // 学校名称（用于教育经历）
          checked: false,
          checked2: false,
          checkList: [],
        }],
      },
    },
    data() {
      return {
        showPrint: true,

      }
    },
    created() {
      document.addEventListener('keydown', function (e) {
        // 检测 Ctrl+P 或 Cmd+P
        if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
          e.preventDefault();
          alert('请点击右下角 ‘打印’ 按钮进行打印！');
        }
      });
    },
    methods: {
      printClick(id) {
        this.$nextTick(() => {
          const printStyle =
            `@media print {
              body {
                margin: 0;
                padding: 0;
              }
              .tabBox {
                width: 210 mm;
                height: 297 mm;
                padding: 5 mm;
                box-sizing: border - box;
              }
              .invoiceTable {
                table-layout: fixed;
                width: 100 % ;
                border-collapse: collapse;
              }
              .invoiceTable tr {
                page-break-inside: avoid;
              }
              .invoiceTable td,
              .invoiceTable th {
                font-size: 12px;
                line-height: 1.5em;
              }
              .printItem {
                page-break-inside: avoid;
                break-inside: avoid;
              }
              .noteBox {
                page-break-inside: avoid;
                break-inside: avoid;
              }
              .noteBot {
                margin-top: 20 px;
                font-size: 24 px;
                font-weight: 600;
                padding: 0 150px 0 10 px;
                font-family: STSong;
              }
              .noteTitle {
                margin-bottom: 20px;
                text-align: center;
                font-size: 24px;
                font-family: STSong;
                text-shadow: 0.15pt 0 0 black, 0.25pt 0 0 black, 0.35pt 0 0 black, -0.25pt 0 0 black, 0 0.25pt 0 black, 0 -0.25pt 0 black;
              }
            };`
          printJS({
            printable: 'printBox',
            type: 'html',
            targetStyles: ['*'],
            style: printStyle,
            font_size: '',
            font_weight: '',
          });
        });
      },
      close() {
        this.$emit('closePrint')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .tabBox {
    background: #fff;
    padding: 30px;
    width: 210mm;
  }

  .noteBox {
    width: 210mm;
    padding: 20px 10px 0 0;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .noteTitle {
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    font-weight: bold !important;
    font-family: STSong;
  }

  .noteBox p {
    margin-bottom: 15px;
    line-height: 1.5em;
    font-size: 16px;
    color: #000;
    font-family: "宋体";
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .font-center {
    text-align: center;
    font-size: 16px;
    padding: 3px 0;
  }

  .titfont {
    font-family: 微软雅黑;
    font-weight: bold;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
    height: 25px;
  }

  .checkBox {
    justify-content: center;
  }

  .ensure {
    padding-left: 2em;
    font-size: 16px;
    color: #000;
    padding-top: 5px;
  }

  .d1 {
    font-size: 16px;
    color: #000;
    padding-top: 5px;
    padding-left: 10px;
    margin-bottom: 30px;
  }

  .d2 {
    font-size: 16px;
    color: #000;
    padding: 10px 30px 5px 5px;
  }

  .signatureBox {
    font-size: 16px;
    justify-content: end;
    display: flex;
    margin-top: 10px;
    color: #000;
    align-items: end;
    padding-right: 30px;
  }

  .signatureTips {
    margin-top: 10px;
    font-size: 14px;
    justify-content: end;
    display: flex;
    color: #000;
  }

  .year {
    width: 60px;
    height: 18px;
    text-align: right;
  }

  .photoBox {
    text-align: center;
    font-size: 18px;
  }

  @media print {
    .tabBox {
      width: 100%;
      max-width: 210mm;
      min-height: 297mm;
      margin: 0 auto;
      padding: 5mm;
      box-sizing: border-box;
    }
  }

  .invoiceTable {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
  }

  .invoiceTable tr {
    page-break-inside: avoid;
  }

  .invoiceTable td,
  .invoiceTable th {
    font-size: 12px;
    line-height: 1.5em;
    // padding: 4px;
  }

  .printItem {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .noteBot {
    margin-top: 20px;
    font-size: 24px;
    font-weight: 600;
    padding: 0 150px 0 10px;
    font-family: STSong;
    align-items: end;
  }

  .butBox {
    padding-left: 30px
  }

  .printMain {
    max-height: 80vh;
    overflow-y: auto;
  }

  .footer {
    display: flex;
    justify-content: end;
    padding: 20px 20px 0 0;
  }

  .signatureIMG img {
    height: 100px;
  }

  .printDate {
    white-space: nowrap;
  }
</style>
<style>
  .page_print .checkBox .el-checkbox__label {
    font-size: 12px;
    font-family: 微软雅黑;
    padding-top: 3px;
  }

  .page_print .checkBox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000 !important;
  }

  .page_print .checkBox .el-checkbox__input.is-checked .el-checkbox__inner,
  .page_print .checkBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #000 !important;
    border-color: #000 !important;
  }
</style>